import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import * as React from 'react'
import { cn } from '~/src/lib/utils'

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ComponentRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    arrowClassName?: string
    hideArrow?: boolean
  }
>(
  (
    {
      className,
      arrowClassName,
      hideArrow = false,
      sideOffset = 5,
      children,
      ...props
    },
    ref
  ) => (
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'bg-popover text-popover-foreground z-50 select-none rounded-md px-3 py-1.5 text-sm shadow-md will-change-[transform,opacity]',
        'data-[state=delayed-open]:animate-in data-[state=closed]:animate-out duration-300',
        'data-[state=delayed-open][data-side=top]:slide-in-from-bottom-2 data-[state=closed][data-side=top]:slide-out-to-bottom-2',
        'data-[state=delayed-open][data-side=bottom]:slide-in-from-top-2 data-[state=closed][data-side=bottom]:slide-out-to-top-2',
        'data-[state=delayed-open][data-side=left]:slide-in-from-right-2 data-[state=closed][data-side=left]:slide-out-to-right-2',
        'data-[state=delayed-open][data-side=right]:slide-in-from-left-2 data-[state=closed][data-side=right]:slide-out-to-left-2',
        '[&_svg]:h-2 [&_svg]:w-3',
        className
      )}
      {...props}
    >
      {children}
      {!hideArrow && (
        <TooltipPrimitive.Arrow
          className={cn('fill-popover', arrowClassName)}
        />
      )}
    </TooltipPrimitive.Content>
  )
)
TooltipContent.displayName = TooltipPrimitive.Content.displayName

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
